import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useContext } from 'react';
import { ListStateContext, GridListContext } from 'react-aria-components';
import { useListState } from 'react-stately';
import GridListInner from './grid-list-inner.esm.js';
import { useContextProps, HiddenContext } from '../../../utils/index.esm.js';
import { CollectionDocumentContext, CollectionPortal, useCollection } from '../collection.esm.js';

// Replicate the pattern used for ListBox to support ComboBox and Select usage.
function GridList(props, ref) {
  var _useContextProps = useContextProps(props, ref, GridListContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var isHidden = useContext(HiddenContext);
  var state = useContext(ListStateContext);
  var document = useContext(CollectionDocumentContext);
  if (document) {
    return /*#__PURE__*/React.createElement(CollectionPortal, props);
  }
  if (state) {
    return isHidden ? null : /*#__PURE__*/React.createElement(GridListInner, {
      state: state,
      props: props,
      gridListRef: ref
    });
  }
  return /*#__PURE__*/React.createElement(StandaloneGridList, {
    props: props,
    gridListRef: ref
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function StandaloneGridList(_ref) {
  var props = _ref.props,
    gridListRef = _ref.gridListRef;
  var _useCollection = useCollection(props),
    collection = _useCollection.collection,
    portal = _useCollection.portal;
  // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
  props = _objectSpread2(_objectSpread2({}, props), {}, {
    collection: collection,
    children: null,
    items: null
  });
  var state = useListState(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, portal, /*#__PURE__*/React.createElement(GridListInner, {
    state: state,
    props: props,
    gridListRef: gridListRef
  }));
}
/**
 * A grid list displays a list of interactive items, with support for keyboard navigation,
 * single or multiple selection, and row actions.
 */
var _GridList = /*#__PURE__*/forwardRef(GridList);

export { _GridList as default };
//# sourceMappingURL=grid-list.esm.js.map
